import React from 'react';
export const Code = ({ id, link, copied, onCopy }) => {
    return (React.createElement("div", { className: "code-container" },
        React.createElement("input", { id: `link-${id}`, type: "text", onFocus: (e) => {
                e.target.select();
            }, onChange: () => { }, value: link }),
        React.createElement("button", { className: "btn--primary", onClick: (_e) => {
                const input = document.getElementById(`link-${id}`);
                if (input) {
                    navigator.clipboard.writeText(input.value);
                    onCopy(id);
                }
            } }, copied ? 'COPIED' : 'COPY')));
};
